import React from "react";
import {
  StyledButton,
  FieldCard,
  FieldLabel,
  CardSelect,
  ToggleSwitch,
  StatusBanner,
  NSDatePicker,
} from "./StyledComponents";
import "react-datepicker/dist/react-datepicker.css";

export function ReportForm({
  stores,
  storeId,
  setStoreId,
  periodKey,
  setPeriodKey,
  businessDateAsDate,
  onBusinessDateChange,
  businessDatePlaceholder,
  force,
  setForce,
  onSubmit,
  submitting = false,
  status,
  dateLimits,
}) {
  const isMonthly = periodKey === "Monthly";

  return (
    <form onSubmit={onSubmit} style={{ display: "grid" }}>
      <FieldCard>
        <FieldLabel>Store</FieldLabel>
        <CardSelect
          value={storeId}
          onChange={(e) => setStoreId(e.target.value)}
          required
          id="store-id"
        >
          {stores.length === 0 && (
            <option value="" disabled>
              Loading stores...
            </option>
          )}
          {stores.map((s) => (
            <option key={s.store_id} value={s.store_id}>
              {s.store_name}
            </option>
          ))}
        </CardSelect>
      </FieldCard>

      <FieldCard>
        <FieldLabel>Period</FieldLabel>
        <CardSelect
          value={periodKey}
          onChange={(e) => setPeriodKey(e.target.value)}
          required
          id="period-key"
        >
          <option>Daily</option>
          <option>Weekly</option>
          <option>Monthly</option>
        </CardSelect>
      </FieldCard>

      <FieldCard>
        <FieldLabel>Business Date ({businessDatePlaceholder})</FieldLabel>
        <NSDatePicker
          selected={businessDateAsDate}
          onChange={onBusinessDateChange}
          dateFormat={isMonthly ? "yyyy-MM" : "yyyy-MM-dd"}
          showMonthYearPicker={isMonthly}
          showYearDropdown
          yearDropdownItemNumber={5}
          maxDate={
            isMonthly
              ? dateLimits?.prevMonth
              : periodKey === "Weekly"
              ? dateLimits?.lastSunday
              : dateLimits?.yesterday
          }
          placeholderText={businessDatePlaceholder}
          // make it look like your inputs
          className="ns-date-icon"
          calendarStartDay={1}
          showIcon
          toggleCalendarOnIconClick
          minDate={dateLimits?.fiveYearsAgo}
          icon={
            <span className="ns-date-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="1em"
                height="1em"
                viewBox="0 0 48 48"
                style={{ padding: "10px !important" }}
              >
                <mask id="ipSApplication0">
                  <g
                    fill="none"
                    stroke="#fff"
                    strokeLinejoin="round"
                    strokeWidth="4"
                  >
                    <path strokeLinecap="round" d="M40.04 22v20h-32V22" />
                    <path
                      fill="#fff"
                      d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                    />
                  </g>
                </mask>
                <path
                  fill="currentColor"
                  d="M0 0h48v48H0z"
                  mask="url(#ipSApplication0)"
                />
              </svg>
            </span>
          }
        />
      </FieldCard>

      <FieldCard>
        <FieldLabel>Force regenerate</FieldLabel>
        <ToggleSwitch aria-label="Force regenerate">
          <input
            type="checkbox"
            role="switch"
            id="force-regenerate"
            checked={force}
            onChange={(e) => setForce(e.target.checked)}
          />
          <span />
        </ToggleSwitch>
      </FieldCard>

      <StyledButton type="submit" disabled={submitting}>
        {submitting ? "Submitting..." : "Generate Report"}
      </StyledButton>
      {status?.message && (
        <StatusBanner variant={status.type === "error" ? "error" : "success"}>
          {status.message}
        </StatusBanner>
      )}
    </form>
  );
}

export default ReportForm;
